import {Component, InputComponent, MeshComponent, Property} from '@wonderlandengine/api';
import {CursorTarget} from '@wonderlandengine/components';
import {AudioSource} from '@wonderlandengine/spatial-audio';

export function hapticFeedback(object, strength, duration) {
    const input = object.getComponent(InputComponent);
    if (input && input.xrInputSource) {
        const gamepad = input.xrInputSource.gamepad;
        if (gamepad && gamepad.hapticActuators)
            gamepad.hapticActuators[0].pulse(strength, duration);
    }
}

export class ButtonComponent extends Component {
    static TypeName = 'button';
    static Properties = {
        buttonMeshObject: Property.object(),
        hoverMaterial: Property.material(),
        clickAudio: Property.audioClip(),
        unClickAudio: Property.audioClip(),
        objectToHide: Property.object(),
        objectToShow: Property.object(),
        displayDuration: Property.float(2.0),
    };

    static onRegister(engine) {
        engine.registerComponent(AudioSource);
        engine.registerComponent(CursorTarget);
    }

    returnPos = new Float32Array(3);
    _scaleOriginalHide = new Float32Array(3);
    _scaleOriginalShow = new Float32Array(3);
    _timeoutId = null;

    start() {
        this.mesh = this.buttonMeshObject.getComponent(MeshComponent);
        this.defaultMaterial = this.mesh.material;
        this.buttonMeshObject.getTranslationLocal(this.returnPos);

        if(this.objectToHide) this.objectToHide.getScalingLocal(this._scaleOriginalHide);
        if(this.objectToShow) {
            this.objectToShow.getScalingLocal(this._scaleOriginalShow);
            this.objectToShow.setScalingLocal([0, 0, 0]);
        }

        this.target = this.object.getComponent(CursorTarget) || this.object.addComponent(CursorTarget);

        if(this.clickAudio) {
            this.soundClick = this.object.addComponent(AudioSource, {
                src: this.clickAudio.source,
                hrtf: true,
            });
        }
        if(this.unClickAudio) {
            this.soundUnClick = this.object.addComponent(AudioSource, {
                src: this.unClickAudio.source,
                hrtf: true,
            });
        }
    }

    onActivate() {
        this.target.onHover.add(this.onHover);
        this.target.onUnhover.add(this.onUnhover);
        this.target.onDown.add(this.onDown);
        this.target.onUp.add(this.onUp);
        // Añadimos onClick específicamente para la lógica de intercambio
        this.target.onClick.add(this.onClick);
    }

    onDeactivate() {
        this.target.onHover.remove(this.onHover);
        this.target.onUnhover.remove(this.onUnhover);
        this.target.onDown.remove(this.onDown);
        this.target.onUp.remove(this.onUp);
        this.target.onClick.remove(this.onClick);
        if(this._timeoutId) clearTimeout(this._timeoutId);
    }

    onHover = (_, cursor) => {
        this.mesh.material = this.hoverMaterial;
        hapticFeedback(cursor.object, 0.5, 50);
    };

    onDown = (_, cursor) => {
        if(this.soundClick) this.soundClick.play();
        this.buttonMeshObject.translate([0.0, -0.1, 0.0]);
        hapticFeedback(cursor.object, 1.0, 20);
    };

    // Separamos la lógica de la escena aquí
    onClick = (_, cursor) => {
        if(this.objectToHide) this.objectToHide.setScalingLocal([0, 0, 0]);
        if(this.objectToShow) this.objectToShow.setScalingLocal(this._scaleOriginalShow);

        if(this._timeoutId) clearTimeout(this._timeoutId);

        this._timeoutId = setTimeout(() => {
            // Verificamos que el componente siga activo antes de restaurar
            if(!this.active) return; 
            
            if(this.objectToHide) this.objectToHide.setScalingLocal(this._scaleOriginalHide);
            if(this.objectToShow) this.objectToShow.setScalingLocal([0, 0, 0]);
            this._timeoutId = null;
        }, this.displayDuration * 1000);
    };

    onUp = (_, cursor) => {
        if(this.soundUnClick) this.soundUnClick.play();
        this.buttonMeshObject.setTranslationLocal(this.returnPos);
        hapticFeedback(cursor.object, 0.7, 20);
    };

    onUnhover = (_, cursor) => {
        this.mesh.material = this.defaultMaterial;
        hapticFeedback(cursor.object, 0.3, 50);
    };
}